/**
 * connected-handlers-desktop.js
 */

import React from 'react';
import { Tooltip, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Link } from 'react-router-dom';
import { UserContext } from 'contexts/user/user-context';
import IconTitle from 'components/icon-title';
import CaptionedSvg from 'components/captioned-svg';
import GroupMemberAvatar from 'components/groups/group-member-avatar';
import { ConnectedHandlersContext } from './connected-handlers-context';
import { connectionsRoute } from './connected-handlers';
import { ReactComponent as ConnectionsSvg } from 'assets/images/connections.svg';


const useStyles = makeStyles(theme => ({
  handlers: {
    marginTop: theme.spacing(0),
    display: 'flex',
    flexWrap: 'wrap',
    width: 700,
    maxWidth: '100%',
    '& > *': {
      margin: `0 ${theme.spacing(1)} ${theme.spacing(2)} 0`
    }
  },
  drawerLink: {
    marginLeft: theme.spacing(2),
    height: 36,
  }
}));


export default function ConnectedHandlersDesktop(props) {
  const classes = useStyles();
  const { user } = React.useContext(UserContext);
  const { handlers } = React.useContext(ConnectedHandlersContext);
  

  return (
    <>
      <IconTitle
        iconType='group-handlers'
        title='Connected Handlers'
        gutterBottom
        subtitle={<>
          {user.role.isHandler && <>You're automatically connected to handlers who share the same supervisor, trainer or training group.</>}
          {user.role.isTrainer && <>You're automatically connected to the training groups of handlers that you directly train. The handlers in these training groups are listed below.</>}
        </>}
      />

      {handlers.length === 0 &&
      <CaptionedSvg
        image={<ConnectionsSvg />}
        text={<>
          {user.role.isHandler && <>You aren't connected with any handlers. When you add a manager or join a training group then you'll see other related handlers listed here.</>}
          {user.role.isTrainer && <>You don't have any connected handlers because you aren't training anyone. Use the <b>+ Member</b> button on the Manage page to invite a handler to be managed.</>}
        </>}
      />}

      <div className={`${classes.handlers}`}>
        {handlers.map(h => (
          <Tooltip
            key={h.id}
            arrow
            placement='top'
            title={h.name}
            children={<span><GroupMemberAvatar name={h.name} /></span>}
          />
        ))}

        {handlers.length > 0 &&
        <Button
          color='primary' 
          className={`flex-hc ${classes.drawerLink}`}
          component={Link} 
          to={connectionsRoute()}
          children={<>View {handlers.length} Handlers</>}
        />}
      </div>
    </>
  )
}